import {
  Button,
  DatePicker,
  Fieldset,
  InputText,
  Legend,
  Select,
} from '@paytrace/pt-skel/Component'
import React, { useState } from 'react'
import { magnifyingGlass } from '@paytrace/pt-skel/Icon'
import PubSub from '@paytrace/pt-skel/Event/PubSub'
import Event from '../../Event'
import RecurringCustomerSelect, { Customer, CustomerSelectProps } from './RecurringCustomerSelect'

export type RecurringFormData = {
  merchant_id: string;
  customerProfile: string;
  frequency: string;
  status: string;
  searchableText: string;
  recurrence?: { id: number };
  dateRange: { startDate: Date; endDate: Date };
};

export const frequencyOptions = [
  { val: '0', name: 'Any Frequency' },
  { val: '1', name: 'Annually' },
  { val: '8', name: 'Semi-Annually' },
  { val: 'A', name: 'Trimesterly' },
  { val: '2', name: 'Quarterly' },
  { val: '9', name: 'Bi-Monthly' },
  { val: '3', name: 'Monthly' },
  { val: '4', name: 'Bi-Weekly' },
  { val: '7', name: '1st and 15th' },
  { val: '5', name: 'Weekly' },
  { val: '6', name: 'Daily' },
]

export const statusOptions = [
  { val: '0', name: 'Any Status' },
  { val: '1', name: 'Active' },
  { val: '2', name: 'Complete' },
]

export const formatDate = (date: Date) => {
  const mm = String(date.getMonth() + 1).padStart(2, '0')
  const dd = String(date.getDate()).padStart(2, '0')
  const yyyy = date.getFullYear()
  return `${mm}/${dd}/${yyyy}`
}

function SearchPayments ({
  formData,
  setFormData,
  currentPage,
  setCurrentPage,
}: {
  formData: RecurringFormData;
  setFormData: (formData: RecurringFormData) => void;
  currentPage: number;
  setCurrentPage: (currentPage: number) => void;
}) {
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    })
  }

  const handleSearchButton = () => {
    setCurrentPage(0)
    const newFormData = {
      formData: {
        ...formData,
        dateRange: {
          startDate: formData.dateRange.startDate
            ? formatDate(formData.dateRange.startDate)
            : formatDate(new Date()),
          endDate: formData.dateRange.endDate
            ? formatDate(formData.dateRange.endDate)
            : formatDate(new Date()),
        },
      },
      currentPage,
      limit: 50,
    }

    PubSub.pub(Event.POST_RECURRING_VIEW_PAYMENT_REQUEST, newFormData)
  }

  const [searchObject] = useState<CustomerSelectProps['searchObject']>(
    {
      limit: 250,
      offset: 0,
      merchantId: formData.merchant_id,
      name_filter: '',
      search_term: '',
    }
  )

  const handleCustomerSelect = (customer: Customer | null) => {
    if (customer?.customer_id) {
      setFormData({
        ...formData,
        customerProfile: customer?.customer_id,
      })
    }
  }

  return (
    <Fieldset>
      <Legend title="Search" />
      <RecurringCustomerSelect
        searchObject={searchObject}
        onCustomerSelect={handleCustomerSelect}
      />
      <Select
        label="Frequency"
        name="frequency"
        options={frequencyOptions}
        onChange={handleChange}
        value={formData.frequency}
      />
      <Select
        label="Status"
        name="status"
        value={formData.status}
        options={statusOptions}
        onChange={handleChange}
      />
      <InputText
        label="Searchable Text"
        name="searchableText"
        onChange={handleChange}
        hintText="Please provide the optional search criteria of the recurring payment(s) you wish to view. This text will be compared against each payment's description, customer id, billing name, email address, tax ID, and discretionary data."
      />
      <DatePicker
        label="From"
        setSelectedDate={(date: Date) => {
          setFormData({
            ...formData,
            dateRange: { ...formData.dateRange, startDate: date },
          })
        }}
        selectedDate={
          formData.dateRange.startDate instanceof Date &&
          !isNaN(formData.dateRange.startDate.getTime())
            ? formData.dateRange.startDate.toISOString().split('T')[0]
            : ''
        }
      />
      <DatePicker
        label="To"
        setSelectedDate={(date: Date) => {
          setFormData({
            ...formData,
            dateRange: { ...formData.dateRange, endDate: date },
          })
        }}
        selectedDate={
          formData.dateRange.endDate instanceof Date &&
          !isNaN(formData.dateRange.endDate.getTime())
            ? formData.dateRange.endDate.toISOString().split('T')[0]
            : ''
        }
      />
      <Button
        className="search-button"
        style={{ background: 'orange' }}
        onClick={handleSearchButton}
      >
        <b className="search-button-icon">{magnifyingGlass}</b> Search
      </Button>
    </Fieldset>
  )
}

export default SearchPayments
